import { render } from "./Chip.vue?vue&type=template&id=341d9e06&scoped=true"
import script from "./Chip.vue?vue&type=script&lang=js"
export * from "./Chip.vue?vue&type=script&lang=js"

import "./Chip.vue?vue&type=style&index=0&id=341d9e06&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-341d9e06"

export default script